import { ready } from '../global/instantiate';
import { initMiniCartDiscount } from '../sections/cart/minicart-discount';

ready(() => {  
  initMiniCartDiscount('cart-sidebar-discount');
});